export const REVISION_TECNICA_HOME = {
  hero_texto:
    'En LEÓN Servicio Automotriz, nos preocupamos por ti y tu vehículo. Queremos ofrecerte una experiencia sin preocupaciones cuando se trata de mantener tu automóvil en excelente estado y pasar la revisión técnica. Aquí te presentamos cómo podemos hacerlo y cuáles son los beneficios para ti:',
  editorial_beneficios:
    'En LEÓN Servicio Automotriz, estamos comprometidos en hacer que el proceso de revisión técnica sea fácil y conveniente para ti, brindándote confianza y transparencia en cada paso del camino. Tu comodidad y seguridad son nuestra prioridad número uno.',
  precio_titulo: 'Valor del Servicio: $65.000***',
  precio_detalle_1:
    '* En caso de que el vehículo requiera un servicio para la gestión efectiva de la revisión técnica, el valor del servicio será de $50.000.',
  precio_detalle_2:
    '** En el caso de que el cliente no quiera realizar el servicio para la exitosa gestión de revisión técnica y solicite la cancelación del servicio, deberá cancelar $30.000.',
  requisitos_intro:
    'Los requisitos para pasar la revisión técnica varían dependiendo del tipo de vehículo y de las regulaciones vigentes. Sin embargo, algunos de los requisitos técnicos comunes que se suelen verificar durante la revisión técnica incluyen:',
  imagen_intro: '/img/revisiontecnica/home/leon_s4.png',
  imagen_precio: '/img/revisiontecnica/home/s8_leon.png',
  imagen_tecnicos: '/img/revisiontecnica/home/s6_1.png',
}

export const REVISION_TECNICA_BENEFICIOS = [
  {
    id: 'retiro-entrega',
    icono: 'retiro-entrega',
    titulo: 'Retiro y entrega a domicilio',
    texto:
      'Olvídate de la molestia de llevar tu vehículo a la revisión técnica. Puedes solicitarnos que retiremos tu automóvil en tu domicilio y, una vez completada la revisión, te lo entregamos de nuevo en perfectas condiciones. Esto te ahorra tiempo y esfuerzo.',
  },
  {
    id: 'revision-exhaustiva',
    icono: 'revision-exhaustiva',
    titulo: 'Revisión exhaustiva',
    texto:
      'Antes de la revisión técnica, llevamos a cabo una minuciosa inspección de tu vehículo. Nos aseguramos de que esté en óptimas condiciones para pasar la revisión técnica. Esto te da la tranquilidad de saber que tu automóvil cumple con los requisitos necesarios.',
  },
  {
    id: 'cotizacion-transparente',
    icono: 'cotizacion-transparente',
    titulo: 'Cotización transparente',
    texto:
      'Si durante la inspección identificamos cualquier problema en tu vehículo, como neumáticos desgastados, frenos en mal estado o luces defectuosas, te proporcionamos una cotización detallada. Tienes la libertad de aprobarla antes de que realicemos cualquier servicio adicional, brindándote control sobre tus gastos.',
  },
  {
    id: 'devolucion',
    icono: 'devolucion',
    titulo: 'Devolución sin compromiso',
    texto:
      'Si decides no realizar los servicios adicionales recomendados o si simplemente deseas volver a tener tu vehículo, te lo devolvemos tal como estaba. No hay obligación de continuar con los servicios si no lo deseas.',
  },
  {
    id: 'costo-retiro',
    icono: 'costo-retiro',
    titulo: 'Costo de retiro transparente',
    texto:
      'En caso de solicitar el retiro del vehículo, aplicamos un cargo por el servicio de retiro, que es transparente y se adapta a tus necesidades.',
  },
]

export const REVISION_TECNICA_REQUISITOS = [
  {
    id: 'luces',
    imagen: '/img/revisiontecnica/home/seccion7_1.png',
    titulo: 'Luces',
    texto:
      'Se verifica el estado y funcionamiento de todas las luces del vehículo, incluyendo faros, luces traseras, luces de freno, intermitentes y luces de posición. Deben estar en buen estado y funcionar correctamente.',
  },
  {
    id: 'frenos',
    imagen: '/img/revisiontecnica/home/seccion7_2.png',
    titulo: 'Frenos',
    texto:
      'Los frenos son evaluados para asegurarse de que sean efectivos y estén en condiciones óptimas. Se comprueba el estado de las pastillas, discos y el sistema de frenado en general.',
  },
  {
    id: 'neumaticos',
    imagen: '/img/revisiontecnica/home/seccion7_3.png',
    titulo: 'Neumáticos',
    texto:
      'Se inspeccionan los neumáticos en busca de desgaste excesivo, cortes, grietas o daños. También se verifica que tengan la presión adecuada y que sean de un tamaño y tipo apropiados.',
  },
  {
    id: 'gases',
    imagen: '/img/revisiontecnica/home/seccion7_4.png',
    titulo: 'Emisión de gases',
    texto:
      'Se mide la emisión de gases del escape para garantizar que cumpla con los límites permitidos de contaminantes. Los vehículos deben estar dentro de los estándares de emisiones establecidos.',
  },
  {
    id: 'direccion-suspension',
    imagen: '/img/revisiontecnica/home/seccion7_5.png',
    titulo: 'Dirección y suspensión',
    texto:
      'Se verifica que la dirección sea precisa y que la suspensión esté en buen estado. Cualquier desgaste o daño en estas áreas puede ser motivo de rechazo.',
  },
  {
    id: 'seguridad',
    imagen: '/img/revisiontecnica/home/seccion7_6.png',
    titulo: 'Sistemas de seguridad',
    texto:
      'Se examinan elementos de seguridad como cinturones de seguridad, airbags, espejos retrovisores y parabrisas. Deben estar en condiciones de funcionamiento adecuadas.',
  },
  {
    id: 'vidrios',
    imagen: '/img/revisiontecnica/home/seccion7_7.png',
    titulo: 'Vidrios',
    texto:
      'Se comprueba que los vidrios estén en buen estado, sin roturas ni fisuras, y que cumplan con las regulaciones sobre vidrios polarizados si es necesario.',
  },
]